(() => {
  const launcher = document.getElementById('dp-launcher');

  if (!launcher) return;

  let dismissed = false;

  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    launcher.classList.add('is-dismissing');
    window.setTimeout(() => launcher.remove(), 450);
  };

  if (document.readyState === 'complete') {
    window.setTimeout(dismiss, 120);
  } else {
    window.addEventListener('load', () => window.setTimeout(dismiss, 120), { once: true });
  }

  window.setTimeout(dismiss, 2500);
})();
